import { useState, useCallback } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import api from "../../service/api";

const CompanySearch = ({
    value = null,
    onChange,
    placeholder = "Search company",
    endpoint = "tms/companies-options",
    className = "render-above",
    isDisabled = false,
}) => {
    const [hasMore, setHasMore] = useState(false);

    const loadOptions = useCallback(
        async (search, loadedOptions, { page }) => {
            if (!search) {
                return {
                    options: [],
                    hasMore: false,
                };
            }

            const response = await api.get(endpoint, {
                search,
                page,
            });

            const { options, hasMore: more } = response;

            setHasMore(more);

            return {
                options,
                hasMore: more,
                additional: {
                    page: page + 1,
                },
            };
        },
        [endpoint]
    );

    return (
        <AsyncPaginate
            isDisabled={isDisabled}
            value={value}
            className={className}
            isClearable
            loadOptions={loadOptions}
            hasMore={hasMore}
            placeholder={placeholder}
            debounceTimeout={800}
            additional={{ page: 1 }}
            onChange={onChange}
        />
    );
};

export default CompanySearch;
